import { getResponseLenses } from 'root/src/shared/descriptions/getEndpointDesc';
import { GET_PROJECT } from 'root/src/shared/descriptions/endpoints/endpointIds';
import getRecordSelector from 'root/src/client/logic/api/selectors/getRecordSelector';
const responseLenses = getResponseLenses(GET_PROJECT);
const { viewCommunityReviewDetails } = responseLenses;
export const communityReviewDetailsSelector = (state, props) => {
    return viewCommunityReviewDetails(getRecordSelector(state, props));
};
